module.exports = "<!-- <div ng-repeat=\"state in items\">\n    <h1><strong>{{ state.title }}</strong></h1>\n    <h4 style=\"font-size: 12.16px;\" ng-repeat=\"item in state.items\"><a href=\"#\" ng-click=\"navigateToState(item)\">{{ item.name }}</a></h4>    \n</div> -->"


//////////////////
// WEBPACK FOOTER
// ./client/app/documentation/static/landing.html
// module id = 89
// module chunks = 0